// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__+1JNT","img":"Hero_img__hGEof","info":"Hero_info__zBls2","btn":"Hero_btn__q9TdD","subTitle":"Hero_subTitle__Ugy7g","title":"Hero_title__Xst-5"};